// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"18545c89","208":"19900dd6","293":"f202e551","516":"3bc2ad5f","917":"6188d3d2","946":"cb9b4500"}[chunkId] + ".chunk.js";
};